import api from './index'

export default async function updateBrokerFunnel(id, funnelStage) {
  try {
    const { data } = await api.post(`/api/funnel/broker/${id}`, {
      funnelStage,
    })
    return data
  } catch (error) {
    return {}
  }
}
